import {Component, Input} from '@angular/core';

@Component({
    selector: 'tfl-bo-data-item',
    template: `
        <div class="data-item">
            <span class="data-item-label">{{ label | translate }}: </span>
            <ng-content></ng-content>
        </div>
    `
})
export class DataItemComponent {

    @Input('label') label: string;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/data-item/data-item.component.ts